import { render, staticRenderFns } from "./TbEditModal.vue?vue&type=template&id=1b9c2204&"
import script from "./TbEditModal.vue?vue&type=script&lang=js&"
export * from "./TbEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports